// @commons
const { APIPost } = require("utilities/APIRequestHelper");
const apiURLBuilder = require("core/apiURLBuilder.js");

// @actions
const signaturePatternActions = require("actions/signaturePattern");

// @constants
const {
    BLOCK_TRUSTED_DEVICE_ERROR,
    BLOCK_TRUSTED_DEVICE_INFO,
    BLOCK_TRUSTED_DEVICE_REQUEST,
    BLOCK_TRUSTED_DEVICE_RESET,
    BLOCK_TRUSTED_DEVICE_SUCCESS,
} = require("constants/actionTypes");

const setBlockTrustedDeviceInfo = (deviceInfo) => ({
    type: BLOCK_TRUSTED_DEVICE_INFO,
    payload: {
        deviceInfo
    }
});

const resetBlockTrustedDevice = () => ({
    type: BLOCK_TRUSTED_DEVICE_RESET
});

const requestBlockTrustedDeviceRequest = () => ({
    type: BLOCK_TRUSTED_DEVICE_REQUEST
});

const requestBlockTrustedDeviceSuccess = (response) => ({
    type: BLOCK_TRUSTED_DEVICE_SUCCESS,
    payload: {
        response
    }
});

const requestBlockTrustedDeviceError = (error) => ({
    type: BLOCK_TRUSTED_DEVICE_ERROR,
    payload: {
        error
    }
});

const requestBlockTrustedDevice = (deviceId, deviceName, isAgentProfileAuthorized) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const requestData = {
            query: isAgentProfileAuthorized 
            ? { blocked: true } 
            : {
                dataToken,
                blocked: true,
                optional1: deviceName
            },
        };

        if(!isAgentProfileAuthorized) {
            requestData.header = {
                version: 2
            };
        }

        dispatch(requestBlockTrustedDeviceRequest());

        return APIPost(
            dispatch,
            apiURLBuilder.getURL(isAgentProfileAuthorized ? "deviceBlock" : "deviceBlockTrusted" , { deviceId }),
            requestData
        )
        .then(response => {
            dispatch(requestBlockTrustedDeviceSuccess(response));
        })
        .catch(response => {
            dispatch(requestBlockTrustedDeviceError(response.error));
        });
    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
}

module.exports = {
    requestBlockTrustedDevice,
    setBlockTrustedDeviceInfo,
    resetBlockTrustedDevice,
}
